export const CustomPaginationActions = ({
    page,
    count,
    rowsPerPage,
    onPageChange,
    totalPages
}) => {
    const currentPage = page + 1;
    const getPages = () => {

        const pages = [];

        if (totalPages <= 5) {
            for (let i = 1; i <= totalPages; i++) {
                pages.push(i);
            }
        } else {

            pages.push(1);

            if (currentPage > 3) {
                pages.push("...");
            }

            for (
                let i = Math.max(2, currentPage - 1);
                i <= Math.min(totalPages - 1, currentPage + 1);
                i++
            ) {
                pages.push(i);
            }

            if (currentPage < totalPages - 2) {
                pages.push("...");
            }

            pages.push(totalPages);
        }

        return pages;
    };

    return (
        <div className="custom-pagination-actions">

            {/* PREVIOUS */}
            <button
                className={`page-btn-prev ${page === 0 ? "disabled" : "active-btn"}`}
                style={page === 0 ? { cursor: "default" } : { cursor: "pointer" }}
                disabled={page === 0}
                onClick={(e) => onPageChange(e, page - 1)}
            >
                Previous
            </button>

            {/* PAGE NUMBERS */}
            {getPages().map((item, index) => {
                return (
                    item === "..." ? (
                        <span key={index}>...</span>
                    ) : (
                        <button
                            key={index}
                            className={`page-btn ${page + 1 === item ? "active-page" : ""}`}
                            onClick={(e) => onPageChange(e, item - 1)}
                            style={page + 1 === item ? { cursor: "default" } : { cursor: "pointer" }}
                        >
                            {item}
                        </button>
                    )
                )
            })}

            {/* NEXT */}
            <button
                className={`page-btn-next ${page >= totalPages - 1 ? "disabled" : "active-btn"} `}
                disabled={page >= totalPages - 1}
                onClick={(e) => onPageChange(e, page + 1)}
                style={page >= totalPages - 1 ? { cursor: "default" } : { cursor: "pointer" }}
            >
                Next
            </button>

        </div>
    );
};